// extracted by mini-css-extract-plugin
export default {"spinIcon":"PaymentCard_spinIcon__drWnC","spin":"PaymentCard_spin__ZZzZ6"};